import type { CupidCardDetail } from "../types/dashboard";
import { apiClient, API_ENDPOINTS } from "../../../config/api";

export async function openCard(cardId: string): Promise<CupidCardDetail> {
  // apiClient가 HTTP 4xx/5xx 시 ApiError(errorType/errorCode 포함)를 throw하므로
  // resultType 체크 없이 result를 반환 — 에러는 그대로 전파됨
  const response = await apiClient.post<{ result: CupidCardDetail; resultType: string }>(
    API_ENDPOINTS.CARDS.OPEN(cardId)
  );
  return response.result;
}

export async function extendCard(cardId: string): Promise<CupidCardDetail> {
  // apiClient가 HTTP 4xx/5xx 시 ApiError(errorType/errorCode 포함)를 throw하므로
  // resultType 체크 없이 result를 반환 — 에러는 그대로 전파됨
  const response = await apiClient.post<{ result: CupidCardDetail; resultType: string }>(
    API_ENDPOINTS.CARDS.EXTEND(cardId)
  );
  return response.result;
}

export async function getCardDetail(cardId: string): Promise<CupidCardDetail> {
  const response = await apiClient.get<{ result: CupidCardDetail; resultType: string }>(
    API_ENDPOINTS.CARDS.DETAIL(cardId)
  );
  
  if (response.resultType !== 'SUCCESS') {
    throw new Error("카드 상세 정보를 불러올 수 없습니다.");
  }
  
  return response.result;
}